module.exports = __webpack_public_path__ + "static/img/img1.d8d5222.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/3/img1.png
// module id = 3HG0
// module chunks = 0